module.exports = __webpack_public_path__ + "static/oracle-associate-9f37c6e6384b55f4cfe8e92cbe46e2fe.png";